module.exports = __webpack_public_path__ + "46b24c9c2faf684b0005f7d9b28ab5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/buetzerBuebeTheme/assets/menu.png
// module id = 2860
// module chunks = 0